import { IEventLoggingComponentProps, withEventLogging } from '@AppModels/Logging';
import { IOperationResultNoValue } from '@ViewModels';
import { embedDashboard } from 'amazon-quicksight-embedding-sdk';
import { StyleDeclarationValue, css } from 'aphrodite';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import {
	ErrorMessagesViewModelKey,
	FullScreenModalViewModelKey,
	IErrorMessageComponentProps,
	IFullscreenModalComponentProps,
} from '../../../models/AppState';
import { QuickSightDashboardViewModel } from '../../../viewmodels/AdminViewModels';
import { MultiContainerHeader } from '../../../web/components/MultiContainerHeader';
import { styleSheet } from './styles';

interface IProps
	extends IEventLoggingComponentProps,
		RouteComponentProps<any>,
		IErrorMessageComponentProps,
		IFullscreenModalComponentProps {
	className?: string;
	styles?: StyleDeclarationValue[];
	vm: QuickSightDashboardViewModel;
}

class _QuickSightDashboard extends React.Component<IProps> {
	private embeddingContainerId = 'quicksight-dashboard';

	public async componentDidMount() {
		const { vm } = this.props;

		const parameters = {
			AccountID: vm.accountId,
			...vm.queryParams,
		};

		vm.load()
			?.then(() => {
				embedDashboard({
					container: document.getElementById(this.embeddingContainerId),
					locale: 'en-US',
					parameters,
					url: vm.quickSightUrl,
				});
			})
			?.catch((err: IOperationResultNoValue) => {
				const { errorMessages, logApiError } = this.props;
				errorMessages.pushApiError(err);
				logApiError('LoadQuickSightDashboard-Error', err);
			});
	}

	public render() {
		const { className, styles } = this.props;

		return (
			<>
				<MultiContainerHeader fullscreenHeader='QuickSight' />
				<div
					id={this.embeddingContainerId}
					className={`${css(styleSheet.container, ...(styles || []))} quicksight-dashboard ${className || ''}`}
				/>
			</>
		);
	}
}

const QuickSightDashboardAsObserver = observer(_QuickSightDashboard);
const QuickSightDashboardWithContext = inject(
	ErrorMessagesViewModelKey,
	FullScreenModalViewModelKey
)(QuickSightDashboardAsObserver);
export const QuickSightDashboard = withEventLogging(QuickSightDashboardWithContext, 'QuickSightDashboard');
